import React, { useEffect, useState } from 'react';
export interface Tab {
  id: string;
  label: string;
  content?: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  activeTab?: string;
  onChange?: (tabId: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  defaultTab,
  activeTab: controlledTab,
  onChange,
  className = ''
}: TabsProps) {
  const [internalTab, setInternalTab] = useState(defaultTab || tabs[0]?.id);
  // Controlled vs uncontrolled
  const isControlled = controlledTab !== undefined && onChange !== undefined;
  const currentTab = isControlled ? controlledTab : internalTab;
  // Reset activeTab when tabs change and current activeTab is not in the new tabs
  useEffect(() => {
    const tabIds = tabs.map(t => t.id);
    if (!tabIds.includes(currentTab)) {
      if (isControlled) {
        onChange(defaultTab || tabs[0]?.id);
      } else {
        setInternalTab(defaultTab || tabs[0]?.id);
      }
    }
  }, [tabs, defaultTab]);
  const handleTabClick = (tabId: string) => {
    if (isControlled) {
      onChange(tabId);
    } else {
      setInternalTab(tabId);
    }
  };
  return <div className={className} data-id="element-18361">
      <div className="border-b border-slate-200 overflow-x-auto hide-scrollbar" data-id="element-18362">
        <nav className="-mb-px flex space-x-2 sm:space-x-6 min-w-max sm:min-w-0" aria-label="Tabs" data-id="element-18363">
          {tabs.map(tab => {
          const isActive = currentTab === tab.id;
          return <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`
                  whitespace-nowrap py-3 px-3 sm:px-1 border-b-2 font-medium text-sm transition-colors
                  ${isActive ? 'border-primary text-primary' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}
                `} aria-current={isActive ? 'page' : undefined} data-id="element-18364">
                {tab.label}
              </button>;
        })}
        </nav>
      </div>
      {/* Only render content area if tabs have content (uncontrolled mode with content) */}
      {tabs.some(t => t.content) && <div className="mt-6" data-id="element-18365">
          {tabs.find(tab => tab.id === currentTab)?.content}
        </div>}
    </div>;
}